<div class="container-date-range-picker">
  <input type="text" class="form-control" [name]="name" [placeholder]="placeholder" #dateRangePicker/>
</div>